import React from 'react';
import { formatNumber } from '../../helpers/formatNumber';

const NotPricedMarker = ({ show }) => (
  show ? <span className="text-danger font-weight-bold">&nbsp;!!!</span> : null
);

export const MapIncomePriceInfo = ({
  confirmedIncomePrice,
  totalIncomePrice,
  isNotPricedPackages,
  orderConfirmedIncomePrice,
  orderTotalIncomePrice,
  exchangeConfirmedIncomePrice,
  exchangeTotalIncomePrice,
}) => {
  const currency = window.routeData.defaultCurrency;

  return (
    <div className="d-flex flex-column map-info-box">
      <div className="map-info-box__section-title">{__('orders.income.title')}</div>
      <div>Potw.: {formatNumber(confirmedIncomePrice)} {currency}</div>
      <div>
        Łącz.: {formatNumber(totalIncomePrice)} {currency}
        <NotPricedMarker show={isNotPricedPackages} />
      </div>

      <div className="map-info-box__section-title">{__('orders.income.orders_income')}</div>
      <div>Potw.: {formatNumber(orderConfirmedIncomePrice)} {currency}</div>
      <div>
        Łącz.: {formatNumber(orderTotalIncomePrice)} {currency}
        <NotPricedMarker show={isNotPricedPackages} />
      </div>

      <div className="map-info-box__section-title">{__('orders.income.exchanges_income')}</div>
      <div>Potw.: {formatNumber(exchangeConfirmedIncomePrice)} {currency}</div>
      <div>
        Łącz.: {formatNumber(exchangeTotalIncomePrice)} {currency}
        <NotPricedMarker show={isNotPricedPackages} />
      </div>
    </div>
  );
};
